import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledNoSearchResultsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 0;
`;

export const StyledNoSearchResultsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const StyledNoSearchResultsText = styled.span`
  ${typographyV2.bodyBase};
  color: var(--text-default);
`;

export const Image = styled.img`
  width: 158px;
  height: 158px;
`;
